import { IStaff, IStaffParams, ITableRes } from 'types'
import { baseApi } from './baseApi'

export const staffAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_staff: builder.query<ITableRes<IStaff>, IStaffParams>({
      query: (params) => ({
          url: '/staff/',
          params: params
      }),
      providesTags: ['staff'],
    }),
    GET_staffById: builder.query<IStaff, string>({
      query: (id) => {
        return {
          url: `/staff/${id}/`,
        }
      },
      providesTags: ['staff-member'],
    }),
    POST_staff: builder.mutation<IStaff, IStaff>({
      query: (body) => ({
        url: `/staff/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['staff'],
    }),
    PUT_staff: builder.mutation<IStaff, { id: string; body: IStaff }>({
      query: ({ id, body }) => ({
        url: `/staff/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['staff', 'staff-member'],
    }),
    DELETE_staff: builder.mutation<IStaff, string>({
      query: (id) => ({
        url: `/staff/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['staff'],
    }),
  }),
})

export const {
  useGET_staffQuery,
  usePOST_staffMutation,
  useGET_staffByIdQuery,
  usePUT_staffMutation,
  useDELETE_staffMutation,
} = staffAPI
